import { useState, useEffect, useContext } from 'react'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import DeleteIcon from '@mui/icons-material/Delete'
import { Link } from 'react-router-dom'
import { getTopThreeFromWidgetRef } from '../../helpers/remoteData'
import { ClientContext } from '../../providers/ClientProvider'
import AttachmentsModal from './components/AttachmentsModal'

function SmartsheetSummaryPrintWidget({ reference, pageUrl, isAdmin, setSelectedWidget, el, moveUp, moveDown }) {
  const { client } = useContext(ClientContext)

  const [loading, setLoading] = useState(false)
  const [rows, setRows] = useState<Array<any>>([])
  const [attachments, setAttachments] = useState<Array<any>>([])

  useEffect(() => {
    const _fetch = async () => {
      setLoading(true)

      try {
        const _rows = await getTopThreeFromWidgetRef(reference, 'dropDate')

        if (_rows) {
          setRows(_rows)
        }

        setLoading(false)
      }
      catch (e) {
        console.log('Print Error')
        
        setRows([])
        setLoading(false)
      }
    }

    _fetch()
  }, [reference])

  return (
    <div className='col-12 col-md-6 col-xl-4 mb-8 d-inline-block'>
      <div className='card shadow h-100'>
        {
          isAdmin && (
            <div className='card-header justify-content-end'>
              <button
                type='button'
                className='btn btn-link btn-sm btn-color-muted btn-color-active-muted d-inline-flex align-items-center justify-content-between mx-2 my-1'
                onClick={() => moveUp(el)}
              >
                <ArrowUpwardIcon />
              </button>
              <button
                type='button'
                className='btn btn-link btn-sm btn-color-muted btn-color-active-muted d-inline-flex align-items-center justify-content-between mx-2 my-1'
                onClick={() => moveDown(el)}
              >
                <ArrowDownwardIcon />
              </button>
              <button
                type='button'
                className='btn btn-link btn-sm btn-color-muted btn-color-active-muted d-inline-flex align-items-center justify-content-between mx-2 my-1'
                data-bs-toggle='modal'
                data-bs-target='#modal_delete_widget'
                onClick={() => setSelectedWidget(el)}
              >
                <DeleteIcon />
              </button>
            </div>
          )
        }
        {
          loading ? 
            <div className='card-body text-center'>
              <div className='spinner-border spinner-border-sm' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </div>
            </div>
          :
            <div className='card-body'>
              <h4 className='d-flex align-items-center mb-0 fw-boldest'>
                <span className='me-3'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M20.295 0.765137H3.70499C3.41999 0.765137 3.17999 1.00514 3.17999 1.29014V18.3451C3.17999 18.3451 3.17999 18.3451 3.17999 18.3601C3.17999 18.3901 3.17999 18.4201 3.19499 18.4501V18.4651C3.19499 18.4951 3.20999 18.5101 3.22499 18.5401C3.22499 18.5551 3.23999 18.5551 3.23999 18.5701C3.25499 18.5851 3.25499 18.6151 3.26999 18.6301C3.26999 18.6451 3.28499 18.6451 3.28499 18.6601C3.29999 18.6901 3.31499 18.7051 3.34499 18.7351L7.70999 23.1001C7.73999 23.1301 7.75499 23.1451 7.78499 23.1601C7.79999 23.1601 7.79999 23.1751 7.81499 23.1751C7.82999 23.1901 7.85999 23.2051 7.87499 23.2051C7.88999 23.2051 7.90499 23.2201 7.91999 23.2201C7.93499 23.2201 7.94999 23.2351 7.97999 23.2351C8.00999 23.2351 8.03999 23.2501 8.08499 23.2501H20.31C20.595 23.2501 20.835 23.0101 20.835 22.7251V1.29014C20.82 1.00514 20.58 0.765137 20.295 0.765137ZM7.54499 21.4351L4.97999 18.8701H7.54499V21.4351ZM19.77 22.1851H8.59499V18.3451C8.59499 18.0601 8.35499 17.8201 8.06999 17.8201H4.22999V1.81514H19.77V22.1851Z" fill={client?.defaultColor ? client.defaultColor : '#F288B7'}/>
                    <path d="M10.41 13.4852C10.41 13.6952 10.575 13.8602 10.785 13.8602H17.505C17.715 13.8602 17.88 13.6952 17.88 13.4852C17.88 13.2752 17.715 13.1102 17.505 13.1102H10.785C10.59 13.1102 10.41 13.2752 10.41 13.4852ZM6.495 13.8602H9.6C9.81 13.8602 9.975 13.6952 9.975 13.4852C9.975 13.2752 9.81 13.1102 9.6 13.1102H6.495C6.285 13.1102 6.12 13.2752 6.12 13.4852C6.12 13.6952 6.285 13.8602 6.495 13.8602ZM17.505 15.1352H13.035C12.825 15.1352 12.66 15.3002 12.66 15.5102C12.66 15.7202 12.825 15.8852 13.035 15.8852H17.505C17.715 15.8852 17.88 15.7202 17.88 15.5102C17.88 15.3002 17.715 15.1352 17.505 15.1352ZM6.495 15.8852H11.85C12.06 15.8852 12.225 15.7202 12.225 15.5102C12.225 15.3002 12.06 15.1352 11.85 15.1352H6.495C6.285 15.1352 6.12 15.3002 6.12 15.5102C6.12 15.7202 6.285 15.8852 6.495 15.8852ZM6.21 9.39016C6.21 9.60016 6.375 9.76516 6.585 9.76516H17.505C17.715 9.76516 17.88 9.60016 17.88 9.39016C17.88 9.18016 17.715 9.01516 17.505 9.01516H6.585C6.39 9.01516 6.21 9.18016 6.21 9.39016ZM17.505 11.0402H13.035C12.825 11.0402 12.66 11.2052 12.66 11.4152C12.66 11.6252 12.825 11.7902 13.035 11.7902H17.505C17.715 11.7902 17.88 11.6252 17.88 11.4152C17.88 11.2052 17.715 11.0402 17.505 11.0402ZM6.495 11.7902H11.85C12.06 11.7902 12.225 11.6252 12.225 11.4152C12.225 11.2052 12.06 11.0402 11.85 11.0402H6.495C6.285 11.0402 6.12 11.2052 6.12 11.4152C6.12 11.6252 6.285 11.7902 6.495 11.7902ZM17.505 19.1852H13.035C12.825 19.1852 12.66 19.3502 12.66 19.5602C12.66 19.7702 12.825 19.9352 13.035 19.9352H17.505C17.715 19.9352 17.88 19.7702 17.88 19.5602C17.88 19.3502 17.715 19.1852 17.505 19.1852ZM11.28 19.1102C11.025 19.1102 10.83 19.3202 10.83 19.5602C10.83 19.8152 11.04 20.0102 11.28 20.0102C11.535 20.0102 11.73 19.8002 11.73 19.5602C11.745 19.3202 11.535 19.1102 11.28 19.1102ZM17.505 17.1602H13.035C12.825 17.1602 12.66 17.3252 12.66 17.5352C12.66 17.7452 12.825 17.9102 13.035 17.9102H17.505C17.715 17.9102 17.88 17.7452 17.88 17.5352C17.88 17.3252 17.715 17.1602 17.505 17.1602ZM11.28 17.0852C11.025 17.0852 10.83 17.2952 10.83 17.5352C10.83 17.7902 11.04 17.9852 11.28 17.9852C11.535 17.9852 11.73 17.7752 11.73 17.5352C11.745 17.2802 11.535 17.0852 11.28 17.0852ZM10.155 7.08016H7.395C6.765 7.08016 6.27 6.57016 6.27 5.95516V5.53516C6.27 4.90516 6.78 4.41016 7.395 4.41016H10.155C10.785 4.41016 11.28 4.92016 11.28 5.53516V5.95516C11.28 6.57016 10.77 7.08016 10.155 7.08016Z" fill={client?.defaultColor ? client.defaultColor : '#F288B7'}/>
                  </svg>
                </span>
                {
                  pageUrl ? 
                    <Link to={pageUrl} className='text-dark'>Latest Projects</Link>
                  :
                    <span>Latest Projects</span>
                }
              </h4>

              <div>
                {
                  rows.length > 0 ?
                    rows.map((r, i) => {
                      return (
                        <div key={`smartsheet-summary-print-${i}`} className='mt-8 d-flex align-items-center'>
                          <div className='ms-4'>
                            <div className='mb-1'>
                              <span
                                className='fw-boldest cursor-pointer text-hover-primary'
                                data-bs-toggle='modal'
                                data-bs-target='#modal_smartsheet_print_summary_attachments'
                                onClick={() => {
                                  setAttachments(r?.attachments)
                                }}
                              >
                                {r?.title}
                              </span>
                            </div>
                            <div className='fs-0 fw-bold'>
                              {r?.jobCode && r?.jobCode.split('_')[0]}
                            </div>
                          </div>
                        </div>
                      )
                    })
                  :
                    <div className='fw-bold mt-8'>No recent campaigns.</div>
                }
              </div>
            </div>
        }
      </div>

      <AttachmentsModal widget='smartsheet_print_summary' attachments={attachments} />
    </div>
  )
}

export default SmartsheetSummaryPrintWidget
